import React, { useEffect } from 'react';
import styles from './AboutUs.module.css';
import Separator from '../../components/Separator';
import NumberCard from '../../components/NumberCard/NumberCard';
import { FiMail } from 'react-icons/fi';
import { BsCheckLg } from 'react-icons/bs';
import { BiChevronsRight } from 'react-icons/bi';
import deskImage from '../../assets/images/desk.jpg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useObserveAnimation } from '../../hooks';
import '../../hooks/animations.css';

const AboutUs = () => {
    const { t } = useTranslation();
    const [topServicesContainerRef, { animateBottom: topServicesContainerClass }] =
        useObserveAnimation();

    useEffect(() => {
        document.title = 'About Us - The Records Hub S.A.';
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className={styles.mainContainer}>
            <div className={styles.section_container}>
                <div className={styles.section_content}>
                    <div className={styles.section_top_container}>
                        <h2 className={styles.h2}>{t('aboutUs.title')}</h2>
                        <Separator
                            widht={'18px'}
                            height={'1.3px'}
                            color={'#f7931d'}
                            marginT={'70px'}
                            marginL={'20px'}
                        />
                    </div>
                    <div className={styles.section_middle_container}>
                        <p className={styles.p}>{t('aboutUs.quote')}</p>
                    </div>
                </div>
            </div>
            <div className={styles.numberCardContainer}>
                <div className={styles.numberCardContentContainer}>
                    <NumberCard
                        symbol={'+'}
                        number={'33'}
                        label={t('aboutUs.numberLabel.clients')}
                        padding={'30px 40px'}
                    />
                    <NumberCard
                        symbol={'+'}
                        number={'59'}
                        label={t('aboutUs.numberLabel.projects')}
                        padding={'30px 40px'}
                    />
                    <NumberCard
                        symbol={'~'}
                        number={'49'}
                        label={t('aboutUs.numberLabel.onGoingProjects')}
                        padding={'30px 24px'}
                    />
                </div>
            </div>
            <div className={styles.statsContainer}>
                <div className={styles.statsContentContainer}>
                    {/* <div
                        className={`${styles.statsContentLeftContainer} ${progressContainerClass}`}
                    >
                        <h2 className={styles.statsTitle}>
                            {t('aboutUs.statsSession.title')}
                            <Separator widht={'30px'} height={'1.5px'} color={'#f7931d'} />
                        </h2>
                        <ProgressBar progress={'98.5'} text={t('aboutUs.statsSession.bar0Label')} />
                        <ProgressBar progress={'96.9'} text={t('aboutUs.statsSession.bar1Label')} />
                        <ProgressBar progress={'92.9'} text={t('aboutUs.statsSession.bar2Label')} />
                        <ProgressBar progress={'96.5'} text={t('aboutUs.statsSession.bar3Label')} />
                    </div> */}
                    <div className={styles.statsContentRightContainer}>
                        <h3 className={styles.rightTitle}>{t('aboutUs.statsSession.subtitle')}</h3>
                        {t('aboutUs.statsSession.description')
                            .split('\n')
                            .map((str, i) => (
                                <p key={`statsSession_description_${i}`}>{str}</p>
                            ))}
                        <div className={styles.contactUsButton}>
                            <Link to='/contact-us' role='button'>
                                {t('aboutUs.contactUsBtn')}
                            </Link>
                            <FiMail size={'20px'} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.topServicesContainer}>
                <div className={styles.topServicesContent} ref={topServicesContainerRef}>
                    <h2 className={`${styles.topServTitle} ${topServicesContainerClass}`}>
                        {t('aboutUs.servicesSession.title')}{' '}
                        <Separator widht={'20px'} height={'1.5px'} color={'#f7931d'} />
                    </h2>
                    <div className={styles.topServSubTitle}>
                        {t('aboutUs.servicesSession.subtitle')}
                    </div>
                    <div className={styles.topCheckLine}>
                        <BsCheckLg className={styles.check} color='#f7931d' />
                        <p>{t('aboutUs.servicesSession.li0')}</p>
                    </div>
                    <div className={styles.topCheckLine}>
                        <BsCheckLg className={styles.check} color='#f7931d' />
                        <p>{t('aboutUs.servicesSession.li1')}</p>
                    </div>
                    <div className={styles.topCheckLine}>
                        <BsCheckLg className={styles.check} color='#f7931d' />
                        <p>{t('aboutUs.servicesSession.li2')}</p>
                    </div>
                    <div className={styles.ourServicesButton}>
                        <Link to='/services' role='button'>
                            {t('aboutUs.ourServicesBtn')}
                        </Link>
                        <BiChevronsRight size={'20px'} />
                    </div>
                </div>
                <img src={deskImage} alt='desk img' />
            </div>
        </div>
    );
};

export default AboutUs;
